import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ProjectContextService } from '../services/project-context.service';

@Injectable()
export class ProjectIdInterceptor implements HttpInterceptor {
  constructor(private readonly projectContext: ProjectContextService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isPublicAuth = ['/auth/login', '/auth/forgot-password', '/auth/password/validate', '/auth/password/set'].some(
      (path) => req.url.includes(path),
    );
    if (isPublicAuth) return next.handle(req);
    const projectId = this.projectContext.projectId;
    if (!projectId) return next.handle(req);

    return next.handle(
      req.clone({
        setHeaders: {
          'x-project-id': projectId,
        },
      }),
    );
  }
}
